blue.ready('accordion', '.accordion', acc => {
	const triggers = [...acc.querySelectorAll('.accordion-trigger')]

	const toggle = function () {
		let item = this.closest('.accordion-item')
		let content = item.querySelector('.accordion-content')
		let heightInit = content.offsetHeight
		let heightFinal

		item.classList.toggle('is-active')

		heightFinal = content.offsetHeight

		content.animate(
			[
				{
					height: `${heightInit}px`
				},
				{
					height: `${heightFinal}px`
				}
			],
			{
				duration: 200,
				easing: 'ease'
			}
		)
	}

	triggers.forEach(trigger => trigger.addEventListener('click', toggle))
})